/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import React, { useContext } from "react"
import { IndexContext } from "../IndexProvider"
import ROLES from "../consts/roles"
import SERVICES from "../consts/services"
import { getHomePageUrl } from "../http/baseUrl"
import PAGES from "../consts/pages"

export default function MenuList() {
    const { accountDetails, breadcrumbs, setBreadcrumbs, pageLoading, setCurrentPage, setPageLoading, getTenantList } = useContext(IndexContext)

    if (!pageLoading && (!accountDetails || !accountDetails.service_id_list)) {
        return (
            <div className="alert alert-danger m-3 text-center" role="alert">
                エラーが発生しました。ログインからやり直してください。
            </div>
        );
    }
    
    const createItem = (innerText, key, classes, onClick = f => f) => {
        return (
            <div className={classes} key={key} style={{ cursor: "pointer" }} onClick={onClick}>
                <div className="w-100 d-flex justify-content-center align-items-center" style={{ height: 70, backgroundColor: "rgb(0, 135, 219)" }}>
                    <span style={{ fontWeight: "bold", color: "#fff", fontSize: 18 }} >{innerText}</span>
                </div>
            </div>
        );
    }

    const createItems = () => {
        const items = []
        let key = 0

        if (accountDetails.service_id_list.includes(SERVICES.RULERLESS) || accountDetails.service_id_list.includes(SERVICES.RULERLESS_IOS)) {
            items.push(createItem("Rulerless Web", key++, "col-6 pt-3 pb-3 ps-3  pe-2", (e) => {
                let url = getHomePageUrl()
                if (url === "http://localhost") {
                    url = `${url}:9003`
                } else {
                    url = `${url}/Rulerless/index.html`
                }
                window.location.href = url
            }))
        }

        if (accountDetails.role === ROLES.SYSTEM_ADMIN || accountDetails.role === ROLES.TENANT_ADMIN) {
            items.push(createItem("設定管理", key++, "col-6 pt-3 pb-3 ps-2  pe-3", async (e) => {
                setBreadcrumbs(breadcrumbs.concat([{ title: "組織一覧", page: PAGES.ORGS }]))
                setPageLoading(true)
                setCurrentPage(PAGES.ORGS)
                await getTenantList()
                setPageLoading(false)
            }))
        }

        return items
    }

    return (
        pageLoading ?
            <div className="row mt-0 ms-0 me-0">
                <div className=" col-6 pt-3 ps-3 pb-3 pe-2 ">
                    <div className="w-100 d-flex justify-content-center align-items-center skeleton-1" style={{ height: 70 }}>
                    </div>
                </div>
                <div className=" col-6 pt-3 ps-2 pb-3 pe-3 ">
                    <div className="w-100 d-flex justify-content-center align-items-center skeleton-1" style={{ height: 70 }}>
                    </div>
                </div>
            </div >
            :
            <div className="row mt-0 ms-0 me-0">
                {createItems()}
            </div >
    );

}